export enum AdmissionRuleEnum {
    BH7Day = 1,
    BH7DayDescription = 'BH - 7 Day',
    PH30Day = 2,
    PH30DayDescription = 'PH - 30 Day'
}
